// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const abstractModalProps = {
    closable: {
        type: Boolean,
        required: false,
        default: true
    },
    open: {
        type: Boolean,
        required: true,
        default: false
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useModal = (props, ctx) => {
    const { emit } = ctx;
    /**
     * Emits the `@close` event to the parent component.
     */
    const close = () => { emit('close'); };
    return { close };
};
